import React, { useState, useEffect } from 'react';
import { Row, Input } from 'antd';
import PropTypes from 'prop-types';
import axios from 'axios';

import CustomModal from '../common/modals/CustomModal';
import OnTraccrButton from '../common/buttons/OnTraccrButton';

import colors from '../constants/Colors';

import { request } from '../helpers/requests';

const buttonStyle = {
  borderRadius: 21,
  width: 110,
  height: 42,
  margin: 20,
};

const inputStyle = {
  width: 500,
  height: 200,
  borderRadius: 20,
  borderColor: colors.ONTRACCR_BLACK,
  margin: 20,
  marginTop: 10,
  marginBottom: 10,
  resize: 'none',
  paddingLeft: 15,
  paddingRight: 15,
  paddingTop: 10,
  paddingBottom: 10,
};

function OttoFeedback({
  visible,
  onClose,
}) {
  const [text, setText] = useState();

  useEffect(() => {
    if (!visible) setText();
  }, [visible]);

  return (
    <CustomModal
      title="Otto Feedback"
      visible={visible}
      onCloseClicked={onClose}
      width={500}
      maskColor={colors.MODAL_MASK_DARK}
    >
      <div style={{ width: '100%' }}>
        <Row style={{ width: '100%' }} type="flex" justify="center">
          <Input.TextArea
            value={text}
            style={inputStyle}
            onChange={(e) => {
              const {
                target: {
                  value,
                } = {},
              } = e;
              setText(value);
            }}
            maxLength={1000}
          />
          <OnTraccrButton
            title="Submit"
            style={buttonStyle}
            disabled={!text || text.length === 0}
            onClick={async () => {
              if (await request({
                call: () => axios.post('/otto/feedback', {
                  feedback: text,
                }),
              })) {
                onClose();
              }
            }}
          />
        </Row>
      </div>
    </CustomModal>
  );
}

OttoFeedback.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OttoFeedback;